/*
 * @Author: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @Date: 2026-04-15 10:42:59
 * @LastEditors: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @LastEditTime: 2026-04-15 10:57:25
 * @FilePath: /work.xhey.top/src/app/hooks/usePhotoLabelLimits.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { useMemo } from 'react'
import { useAppSelector } from '../hooks'
import {
  TEAM_TAG_LIMIT,
  TEAM_GROUP_LIMIT,
  PERSONAL_TAG_LIMIT
} from '../../pages/photoTag/constants'

/**
 * 读取照片标签相关的限制配置
 * 统一由 KV photo_label_team_group_limit 控制，未配置时各自回落本地常量
 */
export function usePhotoLabelLimits() {
  const kvLimit = useAppSelector(
    (state) => state.main.config?.photo_label_team_group_limit
  )

  const parseLimit = (fallback: number) => {
    if (!kvLimit) return fallback
    const n = parseInt(String(kvLimit), 10)
    return isNaN(n) || n <= 0 ? fallback : n
  }

  const teamGroupLimit = useMemo(() => parseLimit(TEAM_GROUP_LIMIT), [kvLimit])
  const teamTagLimitPerGroup = useMemo(
    () => parseLimit(TEAM_TAG_LIMIT),
    [kvLimit]
  )
  const personalTagLimit = useMemo(
    () => parseLimit(PERSONAL_TAG_LIMIT),
    [kvLimit]
  )

  return { teamGroupLimit, teamTagLimitPerGroup, personalTagLimit }
}
